import { render, staticRenderFns } from "./qc.vue?vue&type=template&id=5f57f32c&scoped=true&"
import script from "./qc.vue?vue&type=script&lang=js&"
export * from "./qc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57f32c",
  null
  
)

export default component.exports